/**
 * Localization settings
 */

import { UI_TO_CMS_MAP } from '../../../../../common/cms/cmsLanguageConstants';
import { ExperimentId } from '../../../../../common/experiments/experimentsConstants';

export type LocaleOption = {
    id: string;
    name: string;
};

type AppLocaleConfig = LocaleOption & {
    experimentId?: ExperimentId;
};

export type IsLocaleExperimentEnabled = (experimentId: ExperimentId) => boolean;

const APP_LOCALE_CONFIGS: AppLocaleConfig[] = [
    { id: UI_TO_CMS_MAP.en, name: 'English' },
    { id: UI_TO_CMS_MAP.es, name: 'Español (Spanish)' },
    { id: UI_TO_CMS_MAP.fr, name: 'Français (French)', experimentId: ExperimentId.appLocaleFrench },
    { id: UI_TO_CMS_MAP.de, name: 'Deutsch (German)', experimentId: ExperimentId.appLocaleGerman },
    {
        id: UI_TO_CMS_MAP.pt,
        name: 'Português (Brazilian)',
        experimentId: ExperimentId.appLocalePortugueseBrazilian,
    },
    {
        id: UI_TO_CMS_MAP.zh,
        name: '简体中文 (Chinese, Simplified)',
        experimentId: ExperimentId.appLocaleChineseSimplified,
    },
    { id: UI_TO_CMS_MAP.ru, name: 'Русский (Russian)', experimentId: ExperimentId.appLocaleRussian },
    { id: UI_TO_CMS_MAP.pl, name: 'Polski (Polish)', experimentId: ExperimentId.appLocalePolish },
    { id: UI_TO_CMS_MAP.ja, name: '日本語 (Japanese)', experimentId: ExperimentId.appLocaleJapanese },
    { id: UI_TO_CMS_MAP.nl, name: 'Nederlands (Dutch)', experimentId: ExperimentId.appLocaleDutch },
    { id: UI_TO_CMS_MAP.it, name: 'Italiano (Italian)', experimentId: ExperimentId.appLocaleItalian },
    { id: UI_TO_CMS_MAP.ko, name: '한국어 (Korean)', experimentId: ExperimentId.appLocaleKorean },
];

/**
 * Available app locale options for the user interface.
 * Feature-flagged locales are only included when their experiment is enabled.
 */
export const getAppLanguageOptions = (isLocaleExperimentEnabled?: IsLocaleExperimentEnabled): LocaleOption[] => {
    return APP_LOCALE_CONFIGS.filter(({ experimentId }) => {
        if (!experimentId) return true;
        if (!isLocaleExperimentEnabled) return false;

        return isLocaleExperimentEnabled(experimentId);
    }).map(({ id, name }) => ({ id, name }));
};

export const SUPPORTED_APP_LANGUAGE_CODES = Object.keys(UI_TO_CMS_MAP) as (keyof typeof UI_TO_CMS_MAP)[];

export const DEFAULT_APP_LANGUAGE_CODE = SUPPORTED_APP_LANGUAGE_CODES[0];
